import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
// tslint:disable-next-line:max-line-length
import { RequisitionBackwardActionModalComponent } from 'src/app/pages/mission-control-page/requisitions-page/requisition-card/requisition-backward-action-modal/requisition-backward-action-modal.component';

@Injectable({
  providedIn: 'root'
})
export class RequisitionBackwardActionModalService {

  requisitionBackwardActionModal!: BsModalRef;

  constructor(private bsModalService: BsModalService) { }

  show(modalData: any): void {
    const config = new ModalConfig();
    config.class = 'modal-md custom-ngx-feedback-form-modal';
    config.initialState = modalData;
    this.requisitionBackwardActionModal = this.bsModalService.show(RequisitionBackwardActionModalComponent, config);
  }
}
